import { render, staticRenderFns } from "./quotaIms.vue?vue&type=template&id=40ad094b&scoped=true&"
import script from "./quotaIms.vue?vue&type=script&lang=js&"
export * from "./quotaIms.vue?vue&type=script&lang=js&"
import style0 from "./quotaIms.vue?vue&type=style&index=0&id=40ad094b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad094b",
  null
  
)

export default component.exports